import fastdom from "fastdom";
import { type Ref, ref } from "vue";

export interface BrowserView {
    top: number;
    left: number;
    width: number;
    height: number;
    bottom: number;
    right: number;
}

let browserView: Ref<BrowserView>;

fastdom.measure(() => {
    getBrowserView();
});

function setValues(docEl: HTMLElement) {
    const top = docEl.scrollTop;
    const left = docEl.scrollLeft;
    const width = docEl.clientWidth;
    const height = docEl.clientHeight;
    const newValues: BrowserView = {
        top: top,
        left: left,
        width: width,
        height: height,
        right: width + left,
        bottom: height + top,
    };
    if (browserView == undefined) browserView = ref(newValues);
    else Object.assign(browserView.value, newValues);
}

export function getBrowserView() {
    if (browserView == undefined) {
        setValues(document.documentElement);
        addEventListener("resize", () => setValues(document.documentElement));
        addEventListener("scroll", () => setValues(document.documentElement));
    }
    return browserView;
}
